<template>
  <div class="animated fadeInRight ecommerce">
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('shopBusinessTime.title') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" class="flex justify-start align-center">
          <el-form-item style="margin-bottom: 10px;">
            <span style="margin-right: 5px;">{{ $t('shopBusinessTime.shopLabel') }}：</span>
            <el-select v-model="shopId" :placeholder="$t('shopBusinessTime.selectShop')" style="width: 220px"
              @change="handleShopChange">
              <el-option v-for="item in shops" :key="item.shopId" :label="item.shopName" :value="item.shopId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-alert type="warning" :closable="false" show-icon :title="$t('shopBusinessTime.tipCrossMidnight')">
        </el-alert>
      </div>
    </el-card>

    <el-card class="ibox margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('shopBusinessTime.title') }}</div>
        <div class="ibox-tools">
          <el-button type="primary" size="small" @click="handleSave">
            <i class="el-icon-check"></i> {{ $t('shopBusinessTime.btnSave') }}
          </el-button>
        </div>
      </div>
      <div class="">
        <el-tabs v-model="activeDayType" type="border-card">
          <el-tab-pane v-for="tab in dayTypeTabs" :key="tab.dayType" :name="tab.dayType"
            :label="tab.label + '（' + timesMap[tab.dayType].length + '）'">
            <el-table :data="timesMap[tab.dayType]" style="width: 100%" border>
              <el-table-column type="index" width="60" :label="$t('shopBusinessTime.colIndex')" align="center">
              </el-table-column>
              <el-table-column :label="$t('shopBusinessTime.colStartTime')" align="center">
                <template slot-scope="scope">
                  <el-time-picker v-model="scope.row.startTime" format="HH:mm" value-format="HH:mm"
                    :placeholder="$t('shopBusinessTime.colStartTime')" style="width: 140px">
                  </el-time-picker>
                </template>
              </el-table-column>
              <el-table-column :label="$t('shopBusinessTime.colEndTime')" align="center">
                <template slot-scope="scope">
                  <el-time-picker v-model="scope.row.endTime" format="HH:mm" value-format="HH:mm"
                    :placeholder="$t('shopBusinessTime.colEndTime')" style="width: 140px">
                  </el-time-picker>
                </template>
              </el-table-column>
              <el-table-column :label="$t('shopBusinessTime.colOperation')" align="center" width="120">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger" @click="handleRemoveRow(tab.dayType, scope.row, scope.$index)">
                    {{ $t('shopBusinessTime.btnDelete') }}
                  </el-button>
                </template>
              </el-table-column>
              <template slot="empty">
                <span>{{ $t('shopBusinessTime.emptyText') }}</span>
              </template>
            </el-table>
            <div style="margin-top: 10px;">
              <el-button size="small" @click="handleAddRow(tab.dayType)">
                <i class="el-icon-plus"></i> {{ $t('shopBusinessTime.btnAddSlot') }}
              </el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
  </div>
</template>

<script>
/*
 * 服务码调用点清单（Task 21B，REQ20260904014）：
 * 1. shop.queryShop —— 顶部店铺下拉数据源（shopApi.getShopList 封装，响应取 data 列表）
 * 2. shop.queryShopBusinessTime —— 进入页面/切换店铺时回显存量营业时段（Task 8 既有码，仅返回正常状态行）
 * 3. shop.saveShopBusinessTime —— 整页三页签一次性覆盖式保存（先删后插，times 非空必填）
 * 4. shop.deleteShopBusinessTime —— 已入库行（带 sbtId）的物理删除，删除前二次确认
 */
import { getShopId, getShopList } from '@/api/shop/shopApi'
import { queryShopBusinessTime, saveShopBusinessTime, deleteShopBusinessTime } from '@/api/shop/shopBusinessTimeApi'

const DAY_TYPE_WEEKDAY = 'WEEKDAY'
const DAY_TYPE_WEEKEND = 'WEEKEND'
const DAY_TYPE_HOLIDAY = 'HOLIDAY'
const DAY_TYPES = [DAY_TYPE_WEEKDAY, DAY_TYPE_WEEKEND, DAY_TYPE_HOLIDAY]

export default {
  name: 'ShopBusinessTime',
  data() {
    return {
      shops: [],
      shopId: '',
      activeDayType: DAY_TYPE_WEEKDAY,
      timesMap: {
        [DAY_TYPE_WEEKDAY]: [],
        [DAY_TYPE_WEEKEND]: [],
        [DAY_TYPE_HOLIDAY]: []
      }
    }
  },
  computed: {
    dayTypeTabs() {
      return [
        { dayType: DAY_TYPE_WEEKDAY, label: this.$t('shopBusinessTime.tabWeekday') },
        { dayType: DAY_TYPE_WEEKEND, label: this.$t('shopBusinessTime.tabWeekend') },
        { dayType: DAY_TYPE_HOLIDAY, label: this.$t('shopBusinessTime.tabHoliday') }
      ]
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      try {
        const res = await getShopList({ page: 1, row: 100 })
        this.shops = (res && res.data) || []
      } catch (error) {
        console.error('加载店铺列表失败:', error)
        this.$message.error(this.$t('shopBusinessTime.loadShopFailed'))
      }
      // 单店默认直选当前登录店铺，多店时下拉可切换
      this.shopId = getShopId() || (this.shops.length > 0 ? this.shops[0].shopId : '')
      if (!this.shopId || this.shopId === '-1') {
        this.$message.warning(this.$t('shopBusinessTime.noShop'))
        return
      }
      this.loadTimes()
    },
    handleShopChange() {
      this.loadTimes()
    },
    async loadTimes() {
      if (!this.shopId) return
      try {
        const res = await queryShopBusinessTime({ shopId: this.shopId })
        const emptyMap = { [DAY_TYPE_WEEKDAY]: [], [DAY_TYPE_WEEKEND]: [], [DAY_TYPE_HOLIDAY]: [] }
        const list = (res && res.data) || []
        list.forEach(item => {
          if (emptyMap[item.dayType]) {
            emptyMap[item.dayType].push({
              sbtId: item.sbtId,
              startTime: item.startTime,
              endTime: item.endTime
            })
          }
        })
        this.timesMap = emptyMap
      } catch (error) {
        console.error('加载营业时段配置失败:', error)
        this.$message.error(this.$t('shopBusinessTime.loadFailed'))
      }
    },
    handleAddRow(dayType) {
      this.timesMap[dayType].push({ sbtId: '', startTime: '', endTime: '' })
    },
    async handleRemoveRow(dayType, row, index) {
      // 未入库的新行仅做本地移除；已入库行（带 sbtId）调后端物理删除并二次确认
      if (!row.sbtId) {
        this.timesMap[dayType].splice(index, 1)
        return
      }
      try {
        await this.$confirm(this.$t('shopBusinessTime.confirmDeleteContent'), this.$t('shopBusinessTime.confirmDeleteTitle'), {
          type: 'warning'
        })
      } catch (e) {
        return
      }
      try {
        await deleteShopBusinessTime({ sbtId: row.sbtId })
        this.$message.success(this.$t('shopBusinessTime.deleteSuccess'))
        this.loadTimes()
      } catch (error) {
        console.error('删除营业时段失败:', error)
      }
    },
    timeToMinutes(time) {
      const parts = String(time).split(':')
      return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10)
    },
    // 校验单个页签的时段列表，返回错误文案；空字符串表示通过
    validateDayTypeRows(dayType, rows) {
      const validRows = rows.filter(row => row.startTime || row.endTime)
      for (let i = 0; i < validRows.length; i++) {
        const row = validRows[i]
        if (!row.startTime || !row.endTime) {
          return this.$t('shopBusinessTime.errIncomplete')
        }
        if (row.startTime === row.endTime) {
          return this.$t('shopBusinessTime.errSameTime')
        }
      }
      // 时段不重叠校验：跨零点时段拆为 [start, 24:00) + [00:00, end) 两段后两两判定
      const intervals = validRows.map(row => {
        const start = this.timeToMinutes(row.startTime)
        const end = this.timeToMinutes(row.endTime)
        return start < end ? [[start, end]] : [[start, 24 * 60], [0, end]]
      })
      for (let i = 0; i < intervals.length; i++) {
        for (let j = i + 1; j < intervals.length; j++) {
          for (let k = 0; k < intervals[i].length; k++) {
            for (let m = 0; m < intervals[j].length; m++) {
              const segA = intervals[i][k]
              const segB = intervals[j][m]
              if (segA[0] < segB[1] && segB[0] < segA[1]) {
                return this.$t('shopBusinessTime.errOverlap')
              }
            }
          }
        }
      }
      return ''
    },
    handleSave() {
      const times = []
      for (let i = 0; i < DAY_TYPES.length; i++) {
        const dayType = DAY_TYPES[i]
        const errMsg = this.validateDayTypeRows(dayType, this.timesMap[dayType])
        if (errMsg) {
          this.activeDayType = dayType
          this.$message.warning(errMsg)
          return
        }
        this.timesMap[dayType].forEach(row => {
          if (row.startTime && row.endTime) {
            times.push({ dayType: dayType, startTime: row.startTime, endTime: row.endTime })
          }
        })
      }
      // 全空=清空语义（终审补齐 2026-09-04）：后端允许空数组，覆盖式保存先删后插 0 条，
      // 商户借此恢复店铺默认营业时间；前端二次确认防误点清空
      if (times.length === 0) {
        this.$confirm(this.$t('shopBusinessTime.confirmClear'), this.$t('shopBusinessTime.clearTitle'), {
          confirmButtonText: this.$t('shopBusinessTime.clearConfirm'),
          cancelButtonText: this.$t('shopBusinessTime.clearCancel'),
          type: 'warning'
        }).then(() => {
          this.doSave(times)
        }).catch(() => {})
        return
      }
      this.doSave(times)
    },
    doSave(times) {
      saveShopBusinessTime({ shopId: this.shopId, times: times }).then(() => {
        this.$message.success(this.$t(times.length === 0 ? 'shopBusinessTime.clearSuccess' : 'shopBusinessTime.saveSuccess'))
        this.loadTimes()
      }).catch(error => {
        console.error('保存营业时段配置失败:', error)
        this.$message.error(this.$t('shopBusinessTime.saveFailed'))
      })
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}

.margin-top-sm {
  margin-top: 20px;
}
</style>
